import { ISummaryDeal, ISummaryProduct } from 'store/deal-evaluation/types';

/**
 * Calculate total value of options using formula using ISummaryDeal object
 */
export function calculateNetOptionValueFromDealSummary(dealSummary: ISummaryDeal): number {
  let total = 0;
  if (!dealSummary) {
    return total;
  }
  const fields = ['pull', 'push', 'cap', 'floor', 'earlyTerm', 'extension'];
  fields.forEach(field => {
    total += dealSummary[field];
  });
  return total;
}

/**
 * Calculate total value of options using formula using ISummaryProduct object
 */
export function calculateNetOptionValueFromProductSummary(productSummary: ISummaryProduct): number {
  let total = 0;
  if (!productSummary) {
    return total;
  }
  const { options } = productSummary;
  if (!options) {
    return total;
  }
  const { cap, floor, push, pull, earlyTerm, extension } = options;
  if (cap) {
    total += cap.ave ?? 0;
  }
  if (floor) {
    total += floor.ave ?? 0;
  }
  if (push) {
    total += push.ave ?? 0;
  }
  if (pull) {
    total += pull.ave ?? 0;
  }
  if (earlyTerm) {
    total += earlyTerm.ave ?? 0;
  }
  if (extension) {
    total += extension.ave ?? 0;
  }
  return total;
}
